<template>
  <div class="bind-page">
    <van-nav-bar
      :title="$t('withdraw.wallet_network')"
      left-arrow
      class="bind-nav"
      @click-left="back"
    />

    <div class="bind-body">
      <h2 class="page-title">{{ $t('withdraw.bind_bank_card') }}</h2>
      <p class="page-sub">{{ $t('withdraw.bind_bank_sub') }}</p>

      <div class="tabs">
        <div
          class="tab-item"
          :class="{ active: activeTab === 'virtual' }"
          @click="activeTab = 'virtual'"
        >
          {{ $t('withdraw.tab_virtual') }}
        </div>
      </div>

      <!-- 虚拟地址 -->
      <div v-show="activeTab === 'virtual'" class="tab-panel">
        <template v-if="virtualBound">
          <div v-if="erc20Record" class="addr-block">
            <div class="addr-label">ERC20</div>
            <div class="addr-value">{{ erc20Record.bankid }}</div>
          </div>
          <div v-if="trc20Record" class="addr-block">
            <div class="addr-label">BTC</div>
            <div class="addr-value">{{ trc20Record.bankid }}</div>
          </div>
          <p class="edit-tip" @click="virtualBound = false">{{ $t('withdraw.add_crypto_tip') }}</p>
        </template>
        <template v-else>
          <div class="field-block">
            <div class="field-label">ERC20</div>
            <input
              v-model="erc20"
              type="text"
              class="field-input"
              :placeholder="$t('withdraw.erc20_placeholder')"
            />
          </div>
          <div class="field-block">
            <div class="field-label">BTC</div>
            <input
              v-model="trc20"
              type="text"
              class="field-input"
              placeholder="Please enter BTC address"
            />
          </div>
        </template>
      </div>

      <!-- 银行卡 -->
      <div v-show="activeTab === 'bank'" class="tab-panel">
        <div class="field-block">
          <div class="field-label">{{ $t('setting.username') }}</div>
          <input
            v-model="cardholder"
            type="text"
            class="field-input"
            :placeholder="$t('withdraw.cardholder_placeholder')"
          />
        </div>
        <div class="field-block">
          <div class="field-label">{{ $t('setting.band_name') }}</div>
          <input
            v-model="bankName"
            type="text"
            class="field-input"
            :placeholder="$t('withdraw.bank_name_placeholder')"
          />
        </div>
        <div class="field-block">
          <div class="field-label">{{ $t('setting.band_account') }}</div>
          <input
            v-model="bankAccount"
            type="text"
            class="field-input"
            :placeholder="$t('withdraw.account_placeholder')"
          />
        </div>
        <div class="field-block">
          <div class="field-label">Routing Number</div>
          <input
            v-model="routing"
            type="text"
            class="field-input"
            :placeholder="$t('withdraw.routing_placeholder')"
          />
        </div>
        <div class="field-block">
          <div class="field-label">Payee Address</div>
          <input
            v-model="payeeAddr"
            type="text"
            class="field-input"
            :placeholder="$t('withdraw.payee_placeholder')"
          />
        </div>
        <div class="field-block">
          <div class="field-label">Bank Address</div>
          <input
            v-model="bankAddr"
            type="text"
            class="field-input"
            :placeholder="$t('withdraw.bank_addr_placeholder')"
          />
        </div>
      </div>

      <van-button
        v-if="activeTab !== 'virtual' || !virtualBound"
        class="confirm-btn"
        block
        :loading="submitting"
        @click="onConfirm"
      >
        {{ $t('common.confirm') }}
      </van-button>

      <section class="warn-section">
        <div class="warn-title">{{ $t('withdraw.warning') }}</div>
        <div class="warn-line"></div>
        <p class="warn-text">{{ $t('withdraw.bind_warning') }}</p>
      </section>
    </div>
  </div>
</template>

<script>
const BANK_NETWORK = 'BANK';

export default {
  data() {
    return {
      activeTab: 'virtual',
      submitting: false,
      virtualBound: false,
      erc20Record: null,
      trc20Record: null,
      erc20: '',
      trc20: '',
      cardholder: '',
      bankName: '',
      bankAccount: '',
      routing: '',
      payeeAddr: '',
      bankAddr: '',
    };
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    loadAddresses() {
      return this.$http({ method: 'get', url: 'user_get_bank' }).then((res) => {
        if (res.code !== 200 || !res.data) return;
        const list = res.data.crypto_list || [];
        this.erc20Record = list.find((x) => x.bankfenhang === 'ERC20') || null;
        this.trc20Record = list.find((x) => x.bankfenhang === 'TRC20') || null;
        this.virtualBound = !!(this.erc20Record || this.trc20Record);
        if (this.erc20Record) this.erc20 = this.erc20Record.bankid;
        if (this.trc20Record) this.trc20 = this.trc20Record.bankid;

        const bank = list.find((x) => x.bankfenhang === BANK_NETWORK);
        if (bank) {
          this.bankName = bank.bankinfo || '';
          try {
            const extra = JSON.parse(bank.bankid);
            this.cardholder = extra.cardholder || bank.username || '';
            this.bankAccount = extra.account || '';
            this.routing = extra.routing || '';
            this.payeeAddr = extra.payee || '';
            this.bankAddr = extra.bankAddr || '';
          } catch (e) {
            this.cardholder = bank.username || '';
            this.bankAccount = bank.bankid || '';
          }
        }
      });
    },
    saveCrypto(network, address) {
      return this.$http({
        method: 'post',
        url: 'user_set_crypto_address',
        data: {
          address: address.trim(),
          crypto_type: 'USDT',
          network,
        },
      });
    },
    saveBank() {
      const payload = {
        cardholder: this.cardholder.trim(),
        account: this.bankAccount.trim(),
        routing: this.routing.trim(),
        payee: this.payeeAddr.trim(),
        bankAddr: this.bankAddr.trim(),
      };
      return this.$http({
        method: 'post',
        url: 'user_set_crypto_address',
        data: {
          address: JSON.stringify(payload),
          crypto_type: this.bankName.trim(),
          network: BANK_NETWORK,
        },
      });
    },
    async onConfirm() {
      if (this.activeTab === 'virtual') {
        if (!this.erc20.trim() && !this.trc20.trim()) {
          this.$toast(this.$t('withdraw.wallet_address_tip'));
          return;
        }
        this.submitting = true;
        try {
          if (this.erc20.trim()) {
            const r1 = await this.saveCrypto('ERC20', this.erc20);
            if (r1.code !== 200) {
              this.$toast(r1.msg);
              return;
            }
          }
          if (this.trc20.trim()) {
            const r2 = await this.saveCrypto('TRC20', this.trc20);
            if (r2.code !== 200) {
              this.$toast(r2.msg);
              return;
            }
          }
          this.$toast(this.$t('common.confirm'));
          await this.loadAddresses();
          this.$router.replace({ path: '/Withdraw' });
        } finally {
          this.submitting = false;
        }
        return;
      }

      if (!this.cardholder.trim() || !this.bankName.trim() || !this.bankAccount.trim()) {
        this.$toast(this.$t('setting.fill_bank_tip'));
        return;
      }
      this.submitting = true;
      try {
        const res = await this.saveBank();
        if (res.code === 200) {
          this.$toast(res.msg);
          this.$router.replace({ path: '/Withdraw', query: { method: 'bank' } });
        } else {
          this.$toast(res.msg);
        }
      } finally {
        this.submitting = false;
      }
    },
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
      return;
    }
    const tab = this.$route.query.tab;
    if (tab === 'bank' || tab === 'virtual') {
      this.activeTab = tab;
    }
    this.loadAddresses();
  },
};
</script>

<style scoped>
.bind-page {
  min-height: 100vh;
  background: #fff;
}

.bind-nav {
  background: #fff;
}

.bind-nav::v-deep .van-nav-bar__title {
  color: #111;
  font-weight: 500;
}

.bind-nav::v-deep .van-nav-bar__arrow {
  color: #969799;
}

.bind-body {
  padding: 12px 20px 32px;
}

.page-title {
  margin: 0 0 6px;
  font-size: 17px;
  font-weight: 700;
  color: #111;
}

.page-sub {
  margin: 0 0 20px;
  font-size: 13px;
  color: #969799;
}

.tabs {
  display: flex;
  gap: 32px;
  margin-bottom: 24px;
}

.tab-item {
  font-size: 15px;
  color: #969799;
  padding-bottom: 8px;
  cursor: pointer;
}

.tab-item.active {
  color: #111;
  font-weight: 600;
  border-bottom: 3px solid #ee0a24;
}

.tab-panel {
  min-height: 200px;
}

.field-block {
  margin-bottom: 20px;
}

.field-label {
  font-size: 15px;
  color: #111;
  margin-bottom: 8px;
}

.field-input {
  width: 100%;
  border: none;
  border-bottom: 1px solid #ebedf0;
  padding: 8px 0;
  font-size: 14px;
  outline: none;
  box-sizing: border-box;
}

.field-input::placeholder {
  color: #c8c9cc;
}

.addr-block {
  margin-bottom: 20px;
}

.addr-label {
  font-size: 15px;
  color: #111;
  margin-bottom: 6px;
}

.addr-value {
  font-size: 14px;
  color: #333;
  line-height: 1.5;
  word-break: break-all;
  padding-bottom: 10px;
  border-bottom: 1px solid #ebedf0;
}

.edit-tip {
  font-size: 13px;
  color: #7d3c68;
  margin-top: 12px;
}

.confirm-btn {
  margin-top: 8px;
  height: 48px;
  border: none;
  border-radius: 24px;
  background: #e996ac;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
}

.warn-section {
  margin-top: 36px;
}

.warn-title {
  font-size: 14px;
  color: #666;
  margin-bottom: 10px;
}

.warn-line {
  height: 1px;
  background: #ebedf0;
  margin-bottom: 12px;
}

.warn-text {
  margin: 0;
  font-size: 12px;
  color: #969799;
  line-height: 1.55;
}
</style>
